import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function PostRegistration() {
  const navigate = useNavigate();
  const [userChoice, setUserChoice] = useState('');

  const handleChoiceChange = (event) => {
    setUserChoice(event.target.value);
  };

  const handleNextStep = () => {
    if (userChoice === 'conduct') {
      navigate('/auction-setup'); // Redirect to conduct an auction
    } else if (userChoice === 'participate') {
      navigate('/join-auction'); // Redirect to participate in auction
    } else {
      alert('Please select an option!');
    }
  };

  return (
    <div>
      <h2>Welcome! What would you like to do?</h2>
      <div>
        <label>
          <input
            type="radio"
            value="conduct"
            checked={userChoice === 'conduct'}
            onChange={handleChoiceChange}
          />
          Conduct an Auction
        </label>
        <br />
        <label>
          <input
            type="radio"
            value="participate"
            checked={userChoice === 'participate'}
            onChange={handleChoiceChange}
          />
          Participate in an Auction
        </label>
      </div>
      <button onClick={handleNextStep}>Next</button>
    </div>
  );
}

export default PostRegistration;
